import * as types from "./actionTypes";
import * as MentorLocalizationsService from "../../../Shared/Auto/ApiDefinitions/MentorLocalizationsService";
import { beginApiCall, apiCallError } from "./apiStatusActions";
import { MentorLocalizations } from "../../../Shared/sharedTypes";
import { AppThunk } from "./AppThunk";

interface LocalizationsLoadMessageAction {
    type: typeof types.LOAD_LOCALIZATIONS_SUCCESS;
    localizations: MentorLocalizations;
}

export type LocalizationsActions = LocalizationsLoadMessageAction;

export function loadLocalizationsSuccess(localizations: MentorLocalizations): LocalizationsActions {
    return {
        type: types.LOAD_LOCALIZATIONS_SUCCESS,
        localizations: localizations,
    };
}

export function loadLocalizations(lang: string = "en-US"): AppThunk {
    return function (dispatch, getState) {
        const { mentorAccess } = getState();
        dispatch(beginApiCall());
        return MentorLocalizationsService.localizations(lang, mentorAccess.token)
            .then((localizations) => {
                dispatch(loadLocalizationsSuccess(localizations as any));
            })
            .catch((error) => {
                dispatch(apiCallError());
                throw error;
            });
    };
}
